import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminCheck } from "@/hooks/use-admin-check";
import { Loader2 } from "lucide-react";

export function AdminGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { data, isLoading } = useAdminCheck();

  useEffect(() => {
    if (!isLoading && !data?.isAdmin) {
      navigate("/", { replace: true });
    }
  }, [data, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!data?.isAdmin) {
    return null;
  }

  return <>{children}</>;
}
